const storeName = 'NOTIFY_ME_LIST';

export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    CREATE_NOTIFY_ME_LIST: `${storeName}.CREATE_NOTIFY_ME_LIST`,
    LOAD_NOTIFY_ME_LIST: `${storeName}.LOAD_NOTIFY_ME_LIST`,
    ADD_TO_NOTIFY_ME_LIST: `${storeName}.ADD_TO_NOTIFY_ME_LIST`,
    REMOVE_FROM_NOTIFY_ME_LIST: `${storeName}.REMOVE_FROM_NOTIFY_ME_LIST`,
    SET_NOTIFY_ME_LIST: `${storeName}.SET_NOTIFY_ME_LIST`,
};
